// IDEA: don't fetch `image` via graphql, but create an object for Meili-fetched items instead to reduce the site

import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import Search from "./search"

export default (props) => {
  const data = useStaticQuery(graphql`
    query {
      config: configJson {
        pages {
          articles {
            title
          }
          events {
            title
          }
          news {
            title
          }
          tours {
            title
          }
        }
      }

      sites: allSitesJson {
        nodes {
          id: nk_id
          path
          theTypeData: the_type_data {
            title
          }
          image {
            ...NKimageFragment
          }
        }
      }

      news: allNewsJson {
        nodes {
          id: nk_id
          path
          image {
            ...NKimageFragment
          }
        }
      }

      articles: allArticlesJson {
        nodes {
          id: nk_id
          path
          image {
            ...NKimageFragment
          }
        }
      }

      events: allEventsJson {
        nodes {
          id: nk_id
          path
          image {
            ...NKimageFragment
          }
        }
      }

      tours: allToursJson {
        nodes {
          id: nk_id
          path
          image {
            ...NKimageFragment
          }
        }
      }
    }
  `)

  return <Search {...props} data={data} />
}
